import { StoreState, InstructorExperienceToVerify } from '../types';
import { Epic, combineEpics } from 'redux-observable';
import * as api from '../api';
import { createTryActionsEpic } from './Common';
import { VERIFY_EXPERIENCE, SchoolJobsAction } from '../actions/SchoolJobsActions';

const verifyExperience = async (exp: InstructorExperienceToVerify, { auth }: StoreState) => {
    const user = auth.user;
    if (!user || !user.uid) {
        throw new Error('Tried to verify experience without authenticating');
    }

    if (!exp) {
        throw new Error('Invalid experience');
    }

    return await api.verifyInstructorExperience({ experience: exp });
};

const verifyExperienceEpic: Epic<SchoolJobsAction, SchoolJobsAction, StoreState> =
    createTryActionsEpic(
        VERIFY_EXPERIENCE,
        (a, s) => verifyExperience(a.value, s),
        (a) => a.value);

export default combineEpics<SchoolJobsAction, SchoolJobsAction, StoreState>(
    verifyExperienceEpic
);
